/* eslint-disable */
import axios from '@/services/axios'

export default {

    accountList() {
        return axios.get("/setting/accountList");
    },
    getAccount(data) {
        return axios.get(`/setting/getAccount/${data}`);
    },
    priceList() {
        return axios.get("/setting/priceList");
    },
    getOnePrice(data) {
        return axios.get(`/setting/getOnePrice/${data}`);
    },
    ctgList() {
        return axios.get("/setting/ctgList");
    },
    updateAccount(data){
        return axios.post("/setting/updateAccount", data);
    },
    addAccount(data){
        return axios.post("/setting/addAccount", data);
    },
    delAccount(data){
        return axios.post("/setting/delAccount", data);
    }




    // userList(search) {
    //     return axios.get("/users/userList", {
    //         params: search
    //     });
    // },
    // createUser(data) {
    //     return axios.post("/users/createUser", data);
    // },
    // deleteUser(data) {
    //     return axios.post("/users/deleteUser", data);
    // },



    // list(search) {
    //     return axios.get("/users/search", {
    //         params: search
    //     });
    // },
    // get(id) {
    //     return axios.get(`/users/get/${id}`);
    // },
    // create(data) {
    //     return axios.post("/users/create", data);
    // },
    // delete(data) {
    //     return axios.post("/users/delete", data);
    // },
    // update(data) {
    //     return axios.post("/users/update", data);
    // },
    // changePassword(data) {
    //     return axios.post("/users/change-password", data);
    // },
    // check(email) {
    //     return axios.get(`/users/getByEmail/${email}`);
    // },
    // addUser(data){
    //     return axios.post("/users/addUser", data);
    // },

    // getMaxMemNum(priceId){
    //     return axios.post("/users/getMaxMemNum", priceId);
    // },
    // getNowMemNum(adacctId){
    //     return axios.post("/users/getNowMemNum", adacctId);
    // },

};
